import { PataviumRole } from '../request-and-responses/rest-api/enums/role.enum.model';
import { ContractPermission } from '../request-and-responses/rest-api/enums/contractPermission';
import { BrandType } from '../request-and-responses/rest-api/enums/brandType';
import { CustomerVisibilityType } from '../request-and-responses/rest-api/enums/customerVisibility';

export interface IUserSessionInfo {
    agencyId: number;
    fullName: string;
    userId: number;
    role: PataviumRole;
    permitContracts: ContractPermission;
    customerVisibility: CustomerVisibilityType;
    canExportContract: boolean;
    canDoExportSemplice: boolean;
    canDoExportGas: boolean;
    canDoExportEe: boolean;
    email: string;
    permitBrands: BrandType[];
    username: string;
    teleselling: boolean;
    cf: string;
    canDoAdesioneADistanza: boolean;
    canDoChiamataBenvenuto: boolean;
    canDoPortaUnAmico: boolean;
}

export class UserSessionInfo implements IUserSessionInfo {
    readonly userId: number;
    readonly role: PataviumRole;
    readonly permitContracts: ContractPermission;
    readonly canExportContract: boolean;
    readonly canDoExportSemplice: boolean;
    readonly canDoExportGas: boolean;
    readonly canDoExportEe: boolean;
    readonly email: string;
    readonly username: string;
    readonly permitBrands: BrandType[];
    readonly customerVisibility: CustomerVisibilityType = CustomerVisibilityType.RoleBased;
    readonly teleselling: boolean;
    readonly cf: string;
    readonly fullName: string;
    readonly agencyId: number;
    readonly canDoAdesioneADistanza: boolean;
    readonly canDoChiamataBenvenuto: boolean;
    readonly canDoPortaUnAmico: boolean;

    constructor(user: IUserSessionInfo) {
        this.userId = user.userId;
        this.role = user.role;
        this.permitContracts = user.permitContracts;
        this.canExportContract = user.canExportContract;
        this.canDoExportSemplice = user.canDoExportSemplice;
        this.canDoExportGas = user.canDoExportGas;
        this.canDoExportEe = user.canDoExportEe;
        this.email = user.email;
        this.username = user.username;
        this.permitBrands = user.permitBrands;
        this.customerVisibility = user.customerVisibility;
        this.teleselling = user.teleselling;
        this.cf = user.cf;
        this.fullName = user.fullName;
        this.agencyId = user.agencyId;
        this.canExportContract = user.canExportContract;
        this.canDoAdesioneADistanza = user.canDoAdesioneADistanza === true;
        this.canDoChiamataBenvenuto = user.canDoChiamataBenvenuto === true;
        this.canDoPortaUnAmico = user.canDoPortaUnAmico === true;
    }

    get iAmAdmin(): boolean {
        return this.role === PataviumRole.Admin;
    }
    get iAmPataviumOperator(): boolean {
        return this.role === PataviumRole.BackOfficeOperator;
    }
    get iAmAgency(): boolean {
        return this.role === PataviumRole.Agency;
    }
    get iAmAgent(): boolean {
        return this.role === PataviumRole.Agent;
    }
    get iAmAgencyOperator(): boolean {
        return this.role === PataviumRole.AgencyOperator;
    }
    get iAmSpecializedOperator(): boolean {
        return this.role === PataviumRole.SpecializedOperator;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/frontend/user.session-info.ts